module.exports = __webpack_public_path__ + "static/media/bookmarks.5aa8dc98.svg";